import { ModelExampleVO } from '@wizeoo/akm-common-lib';
import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';

/**
 * Vignette de présentation d'un modèle de codification pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'md-freedata-example-tile-renderer',
  templateUrl: './md-freedata-example-tile.renderer.html',
})
export class MdFreedataExampleTileRenderer implements IWizItemRenderer<null, ModelExampleVO> {
  @ViewChild('mdFreedataExampleTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: ModelExampleVO;
  public get data(): ModelExampleVO {
    return this._data;
  }
  public set data(data: ModelExampleVO) {
    this._data = data;
    this.mdTileRenderer.data = data;
    this.mdTileRenderer.showFooter = false;
  }
}
